import {useState} from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Skeleton} from '@/components/ui/skeleton'
import {Tag} from '@/components/ui/tag'
import {PaginationBar} from '@/components/ui/pagination-bar'
import {useEmpleadoEventos} from '@/hooks/sgsst/incidentes/use-incidentes'
import {formatShortDate} from '@/lib/risk'

/** Eventos donde la persona es afectada o quien reportó, del más grave al más leve. */
export function EmployeeEventosSection({
  businessId,
  employeeId,
  employeeName,
}: {
  businessId: string
  employeeId: string
  employeeName: string
}) {
  const {t} = useTranslation()
  const [page, setPage] = useState(1)
  const {data: eventos, isLoading} = useEmpleadoEventos(businessId, employeeId, page)

  if (isLoading) return <Skeleton className="h-24 w-full" />
  if (!eventos || eventos.total === 0) {
    return (
      <p className="text-sm text-muted-foreground" data-testid="empleado-eventos-empty">
        {t('empleadoEventos.empty', {name: employeeName})}
      </p>
    )
  }
  return (
    <>
      <ul className="divide-y divide-border" data-testid="empleado-eventos-list">
        {eventos.items.map((evento) => (
          <li key={evento.id} className="flex flex-wrap items-center justify-between gap-3 py-3">
            <div className="min-w-0">
              <p className="text-sm text-foreground">
                {t(`incidentes.tipo.${evento.tipo}`)} ·{' '}
                {t(`incidentes.gravedad.${evento.gravedad_derivada ?? evento.gravedad_reportada}`)}
              </p>
              <p className="mt-0.5 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
                <span className="font-mono">{formatShortDate(evento.evento_fecha)}</span>
                <Tag tone="neutral">{t(`empleadoEventos.rol.${evento.rol}`)}</Tag>
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <Tag tone={evento.algo_vencido ? 'red' : evento.algo_por_vencer ? 'amber' : 'green'}>
                {t(`incidentes.estado.${evento.estado}`)}
              </Tag>
              <Link
                to={`/businesses/${businessId}/incidentes/${evento.id}`}
                className="text-xs font-semibold text-primary hover:underline"
                data-testid={`empleado-evento-link-${evento.id}`}>
                {t('empleadoEventos.verDetalle')}
              </Link>
            </div>
          </li>
        ))}
      </ul>
      <PaginationBar page={eventos.page} pageSize={eventos.page_size} total={eventos.total} onPageChange={setPage} />
    </>
  )
}
